import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./codeForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import { InputSelect, BreadCrumb } from "@de-prado-dev/react-component-library";
import { CULTURES, CODE_STATUS } from "../../../../constants/index";
import { Container } from "./codeForm.styled";

const CodeForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    handleSubmit,
    onback,
    edit,
    batchs,
    locations,
    sectors,
    articles,
    varieties,
    onChangeCulture,
    onChangeVariety,
    viveros,
    onChangeVivero,
    onChangeLocation,
    code,
  } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.code.title"), path: PATHS.LIST_code },
    { label: edit ? t("forms.code.titleEdit") : t("forms.code.titleNew") },
  ];

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit ? t("forms.code.titleEdit") : t("forms.code.titleNew")}
          </h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center  ">
        <div className="col-12 col-md-6">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row mb-4 mt-3">
              <div className="col-12">
                <strong>
                  {t("forms.code.labels.code")}: {code}
                </strong>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <div className="row">
                  <div className="col-12">
                    <Field
                      id="batchUuid"
                      labelField={t("forms.code.labels.batch")}
                      name="batchUuid"
                      placeholder=""
                      component={InputSelect}
                      optionLabel="label"
                      optionValue="code"
                      options={batchs.map((item) => ({
                        ...item,
                        label: t(item.label),
                      }))}
                      addOptionEmpty
                      classNamePrefix="dark"
                      mandatory
                    />
                  </div>
                </div>
                <Container className="mt-4">
                  <div className="row">
                    <div className="col-12">
                      <Field
                        id="culture"
                        name="culture"
                        labelField={t("forms.code.labels.culture")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={CULTURES.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        onChangeValue={(value) => {
                          onChangeCulture(value);
                          props.setFieldValue("varietyUuid", "", true);
                          props.setFieldValue("articleUuid", "", true);
                        }}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12">
                      <Field
                        id="varietyUuid"
                        labelField={t("forms.code.labels.variety")}
                        name="varietyUuid"
                        placeholder=""
                        component={InputSelect}
                        optionLabel="label"
                        optionValue="code"
                        options={varieties.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        onChangeValue={(value) => {
                          onChangeVariety(value);
                          props.setFieldValue("articleUuid", "", true);
                        }}
                        addOptionEmpty
                        classNamePrefix="dark"
                        mandatory
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12">
                      <Field
                        id="articleUuid"
                        labelField={t("forms.code.labels.article")}
                        name="articleUuid"
                        placeholder=""
                        component={InputSelect}
                        optionLabel="label"
                        optionValue="code"
                        options={articles.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        addOptionEmpty
                        classNamePrefix="dark"
                        mandatory
                      />
                    </div>
                  </div>
                </Container>
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-12">
                    <Field
                      id="status"
                      name="status"
                      labelField={t("forms.code.labels.status")}
                      component={InputSelect}
                      placeholder=""
                      optionLabel="label"
                      optionValue="code"
                      options={CODE_STATUS.map((item) => ({
                        ...item,
                        label: t(item.label),
                      }))}
                      classNamePrefix="dark"
                    />
                  </div>
                </div>
                <Container className="mt-4">
                  <div className="row">
                    <div className="col-12">
                      <Field
                        id="viveroUuid"
                        name="viveroUuid"
                        labelField={t("forms.code.labels.vivero")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={viveros.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        onChangeValue={(value) => {
                          onChangeVivero(value);
                          props.setFieldValue("locationUuid", "", true);
                          props.setFieldValue("sectorUuid", "", true);
                        }}
                        addOptionEmpty
                        classNamePrefix="dark"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12">
                      <Field
                        id="locationUuid"
                        labelField={t("forms.code.labels.location")}
                        name="locationUuid"
                        placeholder=""
                        component={InputSelect}
                        optionLabel="label"
                        optionValue="code"
                        options={locations.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        onChangeValue={(value) => {
                          onChangeLocation(value);
                          props.setFieldValue("sectorUuid", "", true);
                        }}
                        addOptionEmpty
                        classNamePrefix="dark"
                        mandatory
                      />
                    </div>
                  </div>
                  {sectors && sectors.length > 0 && (
                    <div className="row mt-2">
                      <div className="col-12">
                        <Field
                          id="sectorUuid"
                          labelField={t("forms.code.labels.sector")}
                          name="sectorUuid"
                          placeholder=""
                          component={InputSelect}
                          optionLabel="label"
                          optionValue="code"
                          options={sectors.map((item) => ({
                            ...item,
                            label: t(item.label),
                          }))}
                          addOptionEmpty
                          classNamePrefix="dark"
                          mandatory
                        />
                      </div>
                    </div>
                  )}
                </Container>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onback()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.code.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.code.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

CodeForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const CodeFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "CodeForm",
})(CodeForm);

export default CodeFormF;
